export default __webpack_public_path__ + "static/media/G0120-Child_Advanced_Life_Support_low_res.1709298180000.18cd3c70.jpg";